export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14772.777ffdd9.jpg";